import 'element-ui/lib/theme-chalk/index.css'

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import VueWechatTitle from 'vue-wechat-title';
import ElementUI from 'element-ui';
import clipboard from 'v-clipboard';
import echarts from "echarts";
import 'echarts-liquidfill';

import "./assets/iconfont/iconfont.js";
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";

if (!!window.ActiveXObject || "ActiveXObject" in window) {
  // 不支持IE
  location.href = 'broswer.html';
} else {
  Vue.config.productionTip = false
  Vue.use(ElementUI);
  Vue.use(VueWechatTitle);
  Vue.use(clipboard);
  Vue.prototype.$echarts = echarts;
  Vue.component("svg-icon", SvgIcon);
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}


